import {
  SearchExportState,
  SearchExportActionTypes,
  SEARCH_EXPORT_CLEAR,
  SEARCH_EXPORT_LOADING,
} from 'pages/Search';

const defaultState: SearchExportState = {
  export: [
    {
      header: '',
      assessments: [],
      recordedDocuments: [],
      federalTaxLiens: [],
      liens: [],
      environmentalControlBoardJudgments: [],
      transitAdjudicationBureauJudgments: [],
      parkingViolationJudgments: [],
      uniformCommercialCodes: [],
      emergencyRepairs: [],
    },
  ],
  loading: false,
};

export function searchExportReducer(
  state = defaultState,
  action: SearchExportActionTypes,
): SearchExportState {
  switch (action.type) {
    case SEARCH_EXPORT_CLEAR: {
      // Redux-form is changing defaultState somehow! It's a bug!!!
      return {
        export: [
          {
            header: '',
            assessments: [],
            recordedDocuments: [],
            federalTaxLiens: [],
            liens: [],
            environmentalControlBoardJudgments: [],
            transitAdjudicationBureauJudgments: [],
            parkingViolationJudgments: [],
            uniformCommercialCodes: [],
            emergencyRepairs: [],
          },
        ],
        loading: false,
      };
    }
    case SEARCH_EXPORT_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
